import { Box, Typography } from "@mui/material";

const About = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 3, md: 4 },
          padding: { xs: "20px", sm: "30px", md: "40px" },
          paddingBottom: { xs: "2rem", sm: "4rem", lg: "9rem" },
          backgroundColor: "#F5F5F5",
        }}
      >
        {/* Profile Image */}
        <Box
          component="img"
          src="/profilepicture.jpg" // Replace with actual image path
          alt="About Image"
          sx={{
            width: { xs: "90%", sm: "60%", md: "50%", lg: "30%" },
            maxWidth: { xs: "300px", lg: "none" },
            height: "auto",
            objectFit: "cover",
            borderRadius: "8px",
            marginBottom: { xs: "1.5rem", lg: 0 },
          }}
        />

        {/* About Text */}
        <Box
          sx={{
            width: { xs: "100%", lg: "50%" },
            textAlign: { xs: "left", lg: "left" },
            padding: { xs: "0 10px", sm: "0 15px", md: 0 },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "18px", sm: "20px", md: "24px", lg: "26px" },
              lineHeight: { xs: 1.5, md: 1.7 },
            }}
          >
            Nicole Hahn <br />
            Owner/Principal Designer <br /><br />
            As founder and principal designer, Nicole has been
            interested in art and design from a very young age.
            She holds an Associate Degree in Interior Design from
            FIDM and a Bachelor of Arts Degree in Interior Design
            from Bellevue College&apos;s CIDA-accredited design
            program. Prior to launching NHD, Nicole worked for
            several design companies that have provided her with
            experience in everything from custom furnishings to
            designing multi-million dollar custom homes.
            <br /> <br />
            Nicole has a passion for creating one-of-a-kind spaces
            that encompass an earthy, natural, and timeless design
            style. It is Nicole&apos;s attention to detail and a love for
            design that allows her to create interiors that her clients
            love.
            <br /> <br />
            When Nicole is not designing, she enjoys traveling and
            spending time with her husband and two young daughters
          </Typography>
        </Box>
      </Box>

      {/* Credo Section */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#e6e4df",
          color: "black",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "90%", sm: "85%", md: "75%" },
            textAlign: "center",
            padding: { xs: "20px", sm: "30px", md: "40px" },
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: "0.8rem", sm: "1.4rem", md: "1.4rem", lg: "1.7rem" },
              fontFamily: "'Cinzel', serif",
              fontWeight: 600,
              paddingBottom: { xs: "1.5rem", sm: "2rem", lg: "4rem" },
              paddingTop: { xs: "1.5rem", sm: "2rem", lg: "4rem" },
              lineHeight: { xs: 1.6, md: 1.8 },
            }}
          >
            My Credo <br />
            The oldest thing in your house should not be you. The use of antiques and reclaimed
            materials tell a story, add character, and make a space feel lived in.
            A well designed space is functional, calming, and a direct reflection of the people
            who occupy it. <br />
            The use of natural materials and earthy tones create environments that feel
            authentic and welcoming.<br />
            -N. Hahn
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default About;